import { useContext } from 'react';
import type { AdminNavCountKey } from '@bravemove/types';
import { NavCountsContext, type NavCountsValue } from './NavCountsContext';

/** F60b — every badge count plus `refresh()`, from `NavCountsProvider`. */
export function useNavCounts(): NavCountsValue {
  return useContext(NavCountsContext);
}

/** F60b — one badge count; 0 until loaded, when not permitted, or with no provider. */
export function useNavCount(key: AdminNavCountKey): number {
  return useContext(NavCountsContext).counts[key] ?? 0;
}
